.navbar{
    border-top: 1px solid  #D3D3D3;
    border-bottom: 1px solid  #D3D3D3;
    font-size: 14px;
}

.menuItemFirstActive{
    margin-left: 2vw;
    color: #000;
    border-bottom: 2.5px solid #367c2b;
}

.menuItemActive{
    color: #000;
    border-bottom: 2.5px solid #367c2b;
}

.logout{
    text-decoration: none;
    cursor: pointer;
}

.logout span{
    margin-left: 3px;
    padding: 0;

}
